import "./BlogFooter.css"

export function BlogFooter() {
    return (

        <footer className="bf">
            <br />
            <p>Opinions are my own. </p>
            <div className="bf__see-more">
                <span>wanna see more tech stuff about me? </span>
                <a href="#">
                     not yet -.-
                </a>
            </div>
        </footer>
)
}

export default BlogFooter;

